import { Component, ElementRef, Renderer2 } from '@angular/core'
import { MbConstants } from '../../../../shared/mb-constants'
import { filter, tap } from 'rxjs/operators'
import { MbCheckoutTypes } from '../../../../models'
import { OrderDetailsService } from '@spartacus/order/components'
import { Order } from '@spartacus/order/root'

@Component({
  selector: 'mb-submit-order-confirmation',
  templateUrl: './mb-submit-order-confirmation.component.html',
  styleUrls: ['../mb-submit-order-base.scss']
})
export class MbSubmitOrderConfirmationComponent {

  order$ = this.orderDetailsService.getOrderDetails().pipe(
    tap(order => {
      if (order?.totalItems === 0 || Object.keys(order).length === 0) {
        this.renderer.addClass(this.elem?.nativeElement, 'hide-submit-component')
      } else {
        this.renderer.removeClass(this.elem?.nativeElement, 'hide-submit-component')
      }
    }),
    filter(order => !!order && Object.keys(order).length !== 0),
    tap(order => {
      if (order.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_D ||
        order.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_E) {
        this.isPurchaseCheckout = true
      }
    })
  )
  mbCheckoutType = MbCheckoutTypes
  constants = MbConstants
  isPurchaseCheckout = false

  constructor (protected orderDetailsService: OrderDetailsService,
               private elem: ElementRef,
               private renderer: Renderer2) {
  }

  getTotalQuantityOfTypeOfItems (type: string, order: Order) {
    let counter = 0
    order.entries?.forEach(entry => {
      if (entry?.orderEntryType === type) {
        counter += +(entry?.quantity || 0)
      }
    })
    return counter
  }
}
